import { ReactNode } from 'react';

import {
  HandleDownloadReport,
  HandleOpenCancelDialog,
  HandleOpenDeleteDialog,
  HandleOpenRegenerateDialog,
  HandleOpenRetryDialog
} from '../interfaces';
import { Report, ReportMetadata, STATUS } from '../../interfaces';
import FailedDetails from './pages/failedDetails';
import PendingDetails from './pages/pendingDetails';
import ExpiredDetails from './pages/expiredDetails';
import CreatedDetails from './pages/createdDetails';

interface Props {
  report: Report | undefined;
  generationAllowed: boolean;
  handleOpenDeleteDialog: HandleOpenDeleteDialog;
  handleOpenCancelDialog: HandleOpenCancelDialog;
  handleOpenRegenerateDialog: HandleOpenRegenerateDialog;
  handleOpenRetryDialog: HandleOpenRetryDialog;
  handleCloseDetailsDialog: () => void;
  appliedFilters: (metadata: ReportMetadata) => ReactNode;
  handleDownloadReport: HandleDownloadReport;
}
const Details = ({
  report,
  generationAllowed,
  handleOpenDeleteDialog,
  handleCloseDetailsDialog,
  handleOpenCancelDialog,
  handleOpenRegenerateDialog,
  handleOpenRetryDialog,
  appliedFilters,
  handleDownloadReport
}: Props) => {
  if (!report) {
    return null;
  }

  const getPage = () => {
    switch (report.status) {
      case STATUS.CREATED: {
        return (
          <CreatedDetails
            report={report}
            generationAllowed={generationAllowed}
            handleOpenDeleteDialog={handleOpenDeleteDialog}
            handleCloseDetailsDialog={handleCloseDetailsDialog}
            handleOpenRegenerateDialog={handleOpenRegenerateDialog}
            handleDownloadReport={handleDownloadReport}
            appliedFilters={appliedFilters}
          />
        );
      }
      case STATUS.FAILED: {
        return (
          <FailedDetails
            report={report}
            generationAllowed={generationAllowed}
            handleOpenDeleteDialog={handleOpenDeleteDialog}
            handleOpenRetryDialog={handleOpenRetryDialog}
            handleCloseDetailsDialog={handleCloseDetailsDialog}
            appliedFilters={appliedFilters}
          />
        );
      }
      case STATUS.PENDING: {
        return (
          <PendingDetails
            report={report}
            handleOpenCancelDialog={handleOpenCancelDialog}
            handleCloseDetailsDialog={handleCloseDetailsDialog}
            appliedFilters={appliedFilters}
          />
        );
      }
      case STATUS.EXPIRED: {
        return (
          <ExpiredDetails
            report={report}
            generationAllowed={generationAllowed}
            handleOpenDeleteDialog={handleOpenDeleteDialog}
            handleCloseDetailsDialog={handleCloseDetailsDialog}
            handleOpenRegenerateDialog={handleOpenRegenerateDialog}
            appliedFilters={appliedFilters}
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  return getPage();
};

export default Details;
